import { BookingStateProperties } from '../constants';
import bookingStateSelector from '../selectors/BookingStateSelector';
import patientSelector from '../selectors/PatientSelector';

const canShowCard = (cards, planId) =>
    !(!planId || parseInt(planId, 10) < 0 || !cards || !cards.length);
const getDefaultInsuranceCard = planId => ({
    id: null,
    planId,
    availableInsuranceCardDataId: null,
    isDefault: true,
    cardHasPlan: false,
});

const chooseCard = (cards, planId) => {
    let card;

    for (let i = 0; i < cards.length; i++) {
        const planOnCard = cards[i].planId;
        if (cards[i].planId === planId) {
            card = cards[i];
            break;
        } else if (!card && !planOnCard) {
            card = cards[i];
        }
    }

    return card;
};

const hasValue = value => value && value.trim().length;
const getMemberIdFromCard = card => {
    let memberId = '';
    if (hasValue(card.user_entered_member_id)) {
        memberId = card.user_entered_member_id;
    } else if (hasValue(card.extracted_member_id)) {
        memberId = card.extracted_member_id;
    } else if (hasValue(card.member_id)) {
        memberId = card.member_id;
    }
    return memberId;
};

export function getCurrentInsuranceCard({
    state,
    currentPatientId,
    insuranceCards,
    planId = null,
}) {
    const bookingState = bookingStateSelector(state) || {};
    const patient = patientSelector(state) || {};
    const mainPatientId = (patient.patientId || '-1').toString();
    const planIdInBookingState =
        bookingState[BookingStateProperties.insurancePlanId];
    const patientIdInState = bookingState[BookingStateProperties.patientId];
    currentPatientId = (
        currentPatientId ||
        patientIdInState ||
        '-1'
    ).toString();
    planId = (planId || planIdInBookingState || '-1').toString();

    let card = null;
    if (
        canShowCard(insuranceCards, planId) &&
        currentPatientId === mainPatientId
    ) {
        const choosenCard = chooseCard(insuranceCards, planId);

        if (choosenCard) {
            card = {
                id: choosenCard.id,
                cardHasPlan: choosenCard.planId === planId,
                availableInsuranceCardDataId: parseInt(choosenCard.id, 10),
                memberIdFromCard: getMemberIdFromCard(choosenCard),
                insuranceCardImageUrls: choosenCard.images,
                selectedCardPlanId: planId,
            };
        }
    }

    return card || getDefaultInsuranceCard(planId);
}
